import { render, staticRenderFns } from "./MoveTag.vue?vue&type=template&id=783f57ca&"
import script from "./MoveTag.vue?vue&type=script&lang=js&"
export * from "./MoveTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports